import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { RaisedFistIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { useActionButton } from './hooks/useActionButton';

type Props = {
	to: string;
	socialProof?: boolean;
	buttonName: string;
};

export const ActionButton: React.FC<PropsWithChildren<Props>> = ({ to, socialProof, buttonName, children }) => {
	const {
		data: { socialProofLabel, hiddenOnMobile },
	} = useActionButton();

	return (
		<div
			className={cn(
				'fixed left-0 z-29 mt-0 w-full',
				'shadow-[0px_-0.7px_1.4px_rgba(0,0,0,0.07),0px_-1.9px_4px_rgba(0,0,0,0.05),0px_-4.5px_10px_rgba(0,0,0,0.05),0px_-15px_32px_rgba(0,0,0,0.04)]',
				'md:static md:shadow-none',
				'focus-within:outline-none',
				hiddenOnMobile ? '-bottom-[1000px]' : 'bottom-0 focus-within:bottom-0',
			)}
		>
			<div className="bg-background-raised px-4 py-2 md:bg-transparent md:px-0 md:py-0">
				{socialProof && (
					<div className="rounded-large mb-2 flex flex-row items-center justify-center gap-2 md:hidden">
						<RaisedFistIcon size="x-small" />
						<Text size="small">{socialProofLabel}</Text>
					</div>
				)}

				<Button variant="primary" as="a" href={to} className="w-full md:w-auto" data-qa={`${buttonName}-button`}>
					{children}
				</Button>
			</div>
		</div>
	);
};
